import { useEffect } from "react";
import { useParams } from "react-router-dom";

import useSplitInvite from "./hooks/useSplitInvite";
import SplitInviteView from "./view";

/**
 * Private split-invite controller (§2). Route: splitInvite/:token — a PRIVATE,
 * authenticated route rendered inside the app shell by ProtectedRoutes (exactly
 * like /banking). An unauthenticated visitor is bounced to auth.ginastee.com by
 * AuthContext and returned to this deep link, so the user is always signed in
 * here. Reads the token, runs the invite hook, and renders the view.
 */
export default function SplitInvite() {
  const { token } = useParams();
  const invite = useSplitInvite(token);

  const communityName = invite.community?.name;

  useEffect(() => {
    document.title = communityName
      ? `Convite de split · ${communityName} | Ginastee`
      : "Convite de split | Ginastee";
  }, [communityName]);

  return <SplitInviteView {...invite} />;
}
